import { memoryStore } from "./memory_store";

export const buildSessionStore = () => {
    const store = window.sessionStorage || memoryStore();
    return {
        "get": (key: string) => store.getItem(key) ?? undefined,
        "set": (key: string, value: string) => store.setItem(key, value),
    };
};
